import type { HiveBridge } from '@hive/shared';

declare global {
  interface Window {
    /** Present only inside the Electron window (see apps/desktop/src/preload.ts). */
    hive?: HiveBridge;
  }
}

/** The desktop bridge, or undefined in a plain browser. */
export function desktopBridge(): HiveBridge | undefined {
  return typeof window === 'undefined' ? undefined : window.hive;
}
